import React from "react"
import { MenuBack } from "../../../../component/atoms/MenuBack/index.jsx"
import { Stepper } from "../../../../component/atoms/Stepper/index.jsx"
import { useSettingTargetPage } from "./useSettingTargetPage.js"
import { useHistory } from "react-router-dom"
import { t } from "i18next"
import { Button, Card, Row } from "react-bootstrap"
import { CardBody, CardHeaderTitle } from "../../../../_metronic/_partials/controls/Card.js"
import { Container, Divider } from "@material-ui/core"
import { NoteView, TextInput } from "../../../../component/index.jsx"
import { FormikProvider, getIn } from "formik"
import { ICON_CONSTANTS } from "../../../../constants/ImageConstants.js"
import { stringFormatting, toThousandConvert } from "../../../helpers/TextHelper.js"
import { UNIT_STRING } from "../../../../constants/StringConstant.js"
import { Skeleton } from "@material-ui/lab"

function SettingTargetPage() {
  const page = useSettingTargetPage()
  const history = useHistory()

  function header() {
    return (
      <div
        className={
          "bg-white d-flex justify-content-between align-content-center p-6 border-1 border-bottom border-bottom-light-dark"
        }>
        <MenuBack
          title={t("label_yearly_target")}
          onClick={() => {
            page.uiService.setExitFullPage()
            history.goBack()
          }}
        />
        <Stepper
          step={page.labelStep}
          activeStep={page.isDoneSubRegional ? 1 : 0}
          setActiveStep={page.setActiveForm}
        />
      </div>
    )
  }

  function formRegional() {
    return (
      <Card>
        <CardBody grayBackround>
          <div className={"d-flex justify-content-between align-items-center "}>
            <CardHeaderTitle>
              {`1. ${t("label_target_regional").toString().toUpperCase()}`}
              {page?.activeForm !== 0 && (
                <img className={"pl-4"} src={ICON_CONSTANTS.CHECKLIST} alt={"checklist"} />
              )}
            </CardHeaderTitle>
            {page.activeForm !== 0 && (
              <div>
                <Button onClick={() => page.setActiveForm(0)} variant={"link"}>
                  {t("label_edit")}
                </Button>
              </div>
            )}
          </div>
        </CardBody>
        <Divider />
        <CardBody>
          {page.activeForm === 0 ? (
            <div style={{ display: "grid", gap: 8 }}>
              <NoteView title={t("label_setting_target_note_view_create_edit")} />
              <TextInput
                type={"number"}
                endIcon={<img src={ICON_CONSTANTS.CALENDER_INPUT} alt="caledar" />}
                required
                label={t("label_year")}
                name={"year"}
                editable={false}
              />
              <div className="row">
                {page.formik.values.target.length > 0 ? page.formik.values.target.map((item, i) => {
                  const fieldName = `target[${i}].value`
                  const touched = getIn(page.formik.touched, fieldName)
                  const error = getIn(page.formik.errors, fieldName)
                  return (
                    <div key={i} className="col-12 col-sm-6 col-md-4">
                      <TextInput
                        placeholder={"0"}
                        endIcon={UNIT_STRING.HA}
                        type={"number"}
                        errorMessage={touched && error ? error : ""}
                        required
                        value={page.formik.values.target[i].value}
                        editable={true}
                        label={stringFormatting(item?.label)}
                        name={fieldName}
                      />
                    </div>
                  )
                }) : <Skeleton animation={"wave"} variant={"text"} width={"100%"} height={50} />}
              </div>
              <div className="mt-8 mb-8">
                <Divider />
              </div>
              <div style={{ gap: 8 }} className="d-flex justify-content-end">
                <button onClick={page.onResetRegionalForm} className="btn btn-outline-maxxi">
                  {t("button_reset")}
                </button>
                <Button
                  data-test="button-next-regional"
                  disabled={page.checkDisableButtonRegional()}
                  onClick={() => page.onNextFormRegional()}>
                  {t("button_furthermore")}
                </Button>
              </div>
            </div>
          ) : (
            <div className="">
              <div className="row  ">
                {page.formik.values.target.map((item, i) => (
                  <div
                    key={i}
                    className={`col  ${
                      i !== page.dataTargetRegional.length - 1 ? "border-right" : ""
                    }`}>
                    <div className="text-muted">{stringFormatting(item?.label)}</div>
                    <div className="font-weight-bold" style={{ fontSize: 16 }}>
                      {stringFormatting(toThousandConvert(item?.value), UNIT_STRING.HA)}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </CardBody>
      </Card>
    )
  }

  function formSubRegional() {
    return (
      <Card>
        <CardBody grayBackround>
          <div className={"d-flex justify-content-between align-items-center "}>
            <CardHeaderTitle>
              {`2. ${t("label_target_sub_regional").toString().toUpperCase()}`}
              {page.isDoneSubRegional && page?.activeForm === 1 && (
                <img className={"pl-4"} src={ICON_CONSTANTS.CHECKLIST} alt={"checklist"} />
              )}
            </CardHeaderTitle>
            {page.isDoneSubRegional && page.activeForm === 1 && (
              <div>
                <Button onClick={page.onClickEditSubRegional} variant={"link"}>
                  {t("label_edit")}
                </Button>
              </div>
            )}
          </div>
        </CardBody>
        {page.isDoneRegionalForm && page.activeForm === 1 && (
          <>
            <Divider />
            <CardBody>
              <div style={{ display: "grid", gap: 24 }}>
                <>
                  {!page.isDoneSubRegional && (
                    <NoteView title={t("label_setting_target_note_view_create_edit")} />
                  )}
                  <div className="d-flex w-100 justify-content-between">
                    <div>
                      <h5 className="font-weight-bold">{t("label_total_target_sub_regional")}</h5>
                      <p className="text-muted">
                        {t("label_note_view_setting_target_sub_regional_description")}
                      </p>
                    </div>
                    <div className="row w-50 ">
                      {page.groupSubRegional.map((item, i) => (
                        <div key={i} className="col border-left">
                          <div className="text-muted">{stringFormatting(item?.label)}</div>
                          <h3 className="font-weight-bold">{stringFormatting(toThousandConvert(item?.value), UNIT_STRING.HA)}</h3>
                        </div>
                      ))}
                    </div>
                  </div>
                </>
                {!page.isPreviewSubRegional ? (
                  <>
                    {page.formik.values.sub_regionals.map((item, i) => (
                      <div key={i}>
                        <h2 style={{ fontSize: 16 }}>{stringFormatting(item?.name)}</h2>
                        <div className="mb-8">{stringFormatting(item?.regency_list)}</div>
                        <Row>
                          {item.target &&
                            item.target.map((e, idx) => (
                              <div
                                key={item?.id + e.plant_type_id}
                                className="col-12 col-sm-6 col-md-4">
                                <TextInput
                                  required
                                  endIcon={UNIT_STRING.HA}
                                  type="number"
                                  placeholder={"0"}
                                  editable={true}
                                  label={e.label}
                                  name={`sub_regionals[${i}].target[${idx}].value`}
                                  value={page?.formik.values.sub_regionals?.[i]?.target?.[idx]?.value}
                                  errorMessage={
                                    page?.formik?.touched?.sub_regionals?.[i]?.target?.[idx]
                                      ?.value &&
                                    page?.formik?.errors?.sub_regionals?.[i]?.target?.[idx]?.value
                                  }
                                />
                              </div>
                            ))}
                        </Row>
                      </div>
                    ))}
                  </>
                ) : (
                  <>
                    {page.formik.values.sub_regionals.map((item, i) => (
                      <div key={i} className="d-flex w-100 justify-content-between">
                        <div className="w-50">
                          <h5 className="font-weight-bold">{item.name}</h5>
                          <p className="text-muted">{item.regency_list}</p>
                        </div>
                        <div className="row w-50 ">
                          {item.target.map((v, i) => (
                            <div key={i} className="col border-left">
                              <div className="text-muted">{stringFormatting(v.label)}</div>
                              <h3 className="font-weight-bold">{stringFormatting(toThousandConvert(v.value), UNIT_STRING.HA)}</h3>
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </>
                )}

                {!page?.isPreviewSubRegional && (
                  <div className="d-flex justify-content-end mt-8" style={{ gap: 4 }}>
                    <button onClick={page.onResetSubRegional} className="btn btn-outline-maxxi">
                      {t("button_reset")}
                    </button>
                    <Button
                      data-test="button-next-sub-regional"
                      disabled={page?.checkDisableButtonSubRegional()}
                      onClick={page.onSubmitSubRegional}>
                      {t("button_furthermore")}
                    </Button>
                  </div>
                )}
              </div>
            </CardBody>
          </>
        )}
      </Card>
    )
  }

  return (
    <div>
      {header()}
      <div className="mt-8">
        <FormikProvider value={page.formik}>
          <Container>
            {formRegional()}
            <div style={{ height: 48 }}></div>
            {formSubRegional()}
            <div style={{ height: 48 }}></div>
            <Button
              onClick={() => page.formik.handleSubmit()}
              disabled={page.checkDisableButtonSubmiFinal()}
              className={"w-100"}>
              {t("button_submit")}
            </Button>
          </Container>
        </FormikProvider>
      </div>
    </div>
  )
}

export default SettingTargetPage